import React from 'react';
import { __ } from '@wordpress/i18n';

// components
import ActivityCard from '../ActivityCard';

const ActivityList = ({ activities, emptyLabel, archivedView }) => {
    if (!activities.length) {
        return (
            <p className="commCenter__empty">
                {emptyLabel || __('Nessuna attività da mostrare.', 'soundbetween')}
            </p>
        )
    }

    return (
        <ul className="activityList">
            {activities.map(activity => (
                <ActivityCard key={activity.id} activity={activity} archivedView={archivedView}/>
            ))}
        </ul>
    )
}

export default ActivityList;
